import React from 'react';
import ReactSelect from 'react-select';
import { withFormsy } from 'formsy-react';
import Chevron from '../../svg/Chevron.js';
import { get as _get } from 'lodash';

class Select extends React.Component {
  state = {
    selectedOption: { value: '' },
  };

  render = () => {
    const { selectedOption } = this.state;
    const {
      name,
      options,
      isValid,
      isPristine,
      showValid,
      required,
      placeholder,
      isMulti,
      isClearable
    } = this.props;

    const availOpts = options || [];
    const value = selectedOption && selectedOption.value;
    let selectedObj = availOpts.find(opt => opt.value === value)

    if (isMulti) {
      // TODO cleanup?
      selectedObj = value && Array.isArray(value)
        && value.map(selOpt => availOpts.find(opt => selOpt.value === opt.value))
        .filter(opt => opt);
    }

    let className = this.props.newStyles ? 'select-new' : 'select';
    className += isValid || isPristine ? '' : ' error';
    className += showValid === true && isValid ? ' valid' : '';

    const inputProps = {
      name,
      value: selectedObj,
      options,
      className,
      classNamePrefix: "select-new",
      onChange: this.handleChange,
      required,
      placeholder,
      readOnly: true,
      searchable: false,
      isClearable: isClearable === false ? false : true,
      isMulti: !!isMulti,
      'aria-label': name,
      arrowRenderer: this.props.newStyles ? this.arrowRenderer : undefined, // undefined is the default value (react-select)
    };

    return (
      <div>
        <ReactSelect {...inputProps} />
      </div>
    );
  };

  handleChange = (selectedOption) => {
    if (this.props.onChangePitStop) this.props.onChangePitStop();

    this.setState({ selectedOption });
    if ('onChange' in this.props) this.props.onChange(selectedOption);
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    let nextValue = _get(nextProps, 'value.value') || nextProps.value
    if (
      prevState.selectedOption &&
      nextValue !== prevState.selectedOption.value
    )
      return {
        selectedOption: {
          value: nextValue
        }
      };
    else return null;
  }

  arrowRenderer() {
    return <Chevron />;
  }
}

export default withFormsy(Select);



// WEBPACK FOOTER //
// ./src/components/form/Select.js